import { render, staticRenderFns } from "./dialogDataSource.vue?vue&type=template&id=32516b73&scoped=true&lang=html"
import script from "./dialogDataSource.vue?vue&type=script&lang=js"
export * from "./dialogDataSource.vue?vue&type=script&lang=js"
import style0 from "./dialogDataSource.vue?vue&type=style&index=0&id=32516b73&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32516b73",
  null
  
)

export default component.exports